import * as React from "react";
import {useMemo, useState} from "react";
import {IInactiveUserRow} from "../../../../api/AdminAnalyticsApi";
import {applySort, SortDir} from "../../../../utils/listUtil";
import {sortTh} from "../shared/SortableTh.component";
import {INACTIVE_USERS_DESCRIPTION} from "../shared/analytics.constants";
import {formatUserType} from "../shared/analytics.format";
import {numberWithCommas} from "../../../../utils/numberUtil";

interface IInactiveUsersTableProps {
    inactiveUsers: IInactiveUserRow[];
    inactiveCount: number;
}

export const InactiveUsersTable: React.FC<IInactiveUsersTableProps> = (props) => {
    const [inactiveSort, setInactiveSort] = useState<{ col: string; dir: SortDir }>({
        col: "daysSinceLogin",
        dir: "desc",
    });
    const [showInactiveTable, setShowInactiveTable] = useState<boolean>(false);
    const sortedInactiveUsers = useMemo(
        () => applySort(props.inactiveUsers, inactiveSort.col, inactiveSort.dir),
        [props.inactiveUsers, inactiveSort]);

    return (
        <section className="admin-analytics__section" data-testid={"inactive-users"}>
            <div className="admin-analytics__section-header">
                <h2 className="admin-analytics__section-title">Inactive Users / Churn Risk</h2>
                <span className="admin-analytics__section-subtitle">
                    Users who logged in before this period but not during it
                </span>
            </div>
            <p className="admin-analytics__section-desc">{INACTIVE_USERS_DESCRIPTION}</p>
            <div className="admin-analytics__summary-grid">
                <div className="admin-analytics__summary-card admin-analytics__summary-card--total">
                    <div className="admin-analytics__summary-label">At-Risk Users</div>
                    <div className="admin-analytics__summary-value">{numberWithCommas(props.inactiveCount)}</div>
                    <div className="admin-analytics__summary-note">did not log in during selected
                        period
                    </div>
                </div>
            </div>
            {props.inactiveUsers.length > 0 && (
                <>
                    <button className="admin-analytics__show-more-btn"
                            onClick={() => setShowInactiveTable(!showInactiveTable)}>
                        {showInactiveTable
                            ? "Hide user list"
                            : `Show top ${props.inactiveUsers.length} at-risk users`}
                    </button>
                    {showInactiveTable && (
                        <table className="admin-analytics__table" style={{marginTop: 12}}>
                            <thead>
                            <tr>
                                {sortTh("user", "User", inactiveSort, setInactiveSort, undefined, "asc")}
                                {sortTh("userType", "User Type", inactiveSort, setInactiveSort, undefined, "asc")}
                                {sortTh("lastLogin", "Last Login", inactiveSort, setInactiveSort)}
                                {sortTh("daysSinceLogin", "Days Since Login", inactiveSort, setInactiveSort,
                                    "admin-analytics__cell--right")}
                            </tr>
                            </thead>
                            <tbody>{sortedInactiveUsers.map((row) => (
                                <tr key={row.user}>
                                    <td>{row.user}</td>
                                    <td>{formatUserType(row.userType)}</td>
                                    <td>{row.lastLogin}</td>
                                    <td className="admin-analytics__cell--right">{row.daysSinceLogin}</td>
                                </tr>
                            ))}</tbody>
                        </table>
                    )}
                </>
            )}
        </section>
    );
};
